module.exports = __webpack_public_path__ + "img/faq-temp.918b35a7.webp";